import { SelectedMetaData } from '../providers/PaymentProvider';

export const getUniqueDiscounts = (dataList: SelectedMetaData[]) => {
  const seenDiscounts = new Set();
  const uniqueDiscounts: SelectedMetaData[] = [];

  dataList.forEach((item) => {
    if (!seenDiscounts.has(item.discountPercentage)) {
      seenDiscounts.add(item.discountPercentage);
      uniqueDiscounts.push(item);
    }
  });

  return uniqueDiscounts;
};
